import { useEffect, useState } from 'react'
import {
  useAccount,
  useNetwork
} from 'wagmi'

const useConnection = (
  initialized: boolean | null,
  initialize: any,
  reinitialize: any,
  urlChainId?: string | null,
  urlTokenAddress?: string,
) => {
  const account = useAccount()
  const { address, isConnected: active, connector } = account
  const { chain } = useNetwork()
  const connectorChainId = chain ? chain.id : null
  const [ start, setStart ] = useState<boolean>(false)
  useEffect(() => {
    setStart(true)
  }, [])

  useEffect(() => {
    if (!active) { return }
    if (!start) { return }
    if (!initialized) {
      initialize(
        connector,
        urlChainId || connectorChainId,
        address,
      )
    } else {
      if (address) {
        reinitialize(
          address,
          urlTokenAddress,
          connector
        )
      }
    }
  }, [start, address, connector, active, urlTokenAddress, connectorChainId])

  return {
    address, 
    connector,
    active
  }
}

export default useConnection
